import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "./../../../environments/environment";
import { ApiHelper } from "./../../_helpers/api.helper";
import { CommonHelper } from "./../../_helpers/common.helper";
import { AppConfig } from "./../../../app/app.config";
import { ConstantHelper } from "./../../_helpers/constant.helper";
import { SweetAlertHelper } from "src/app/_helpers/sweet.alert.helper";
import { Message } from "src/app/_locale/message";
import { async } from "@angular/core/testing";
declare let $: any;

@Component({
  selector: "app-doc-review",
  templateUrl: "./doc-review.component.html",
  styleUrls: ["./doc-review.component.scss"],
  providers: [AppConfig, CommonHelper],
})
export class DocReviewComponent implements OnInit {
  loggedInUserId: string;
  demographicId: string;
  resultJsonObj: any = {};
  hidePdfPopUp = false;
  demographicUrl: SafeResourceUrl;
  hippaUrl: SafeResourceUrl;
  disclaimerUrl: SafeResourceUrl;
  ahsDisclaimerPdf: SafeResourceUrl;
  ahsHippaPdf: SafeResourceUrl;
  showDocThumbnails = true;
  ahsPdfUrl: SafeResourceUrl = "";
  documentsLength = false;
  documentsList: any;
  docGroupId: any;
  docGroupTitle: any;
  docSet: any;
  docTyep: any;
  companyDefaultGroupTitle: any;
  companyDefaultGroupId: any;
  activeGroupId: any;
  selectedDocId: any;
  signedGroups: any = [];
  signedGroupsCount: any;

  httpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });
  httpOptions = {
    headers: this.httpHeaders,
  };

  profileObj: any;
  showDeleteButton = false;
  message = Message;
  showHippaUpdateBtn: string;

  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    public sweetAlertHelper: SweetAlertHelper,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.showHippaUpdateBtn = localStorage.getItem("showHippaUpdateBtn");

    this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl("");
    this.loggedInUserId =
      this.activatedRoute.snapshot.paramMap.get("loggedInUserId");
    this.demographicId =
      this.activatedRoute.snapshot.paramMap.get("demographicId");

    $(document).ready(function () {
      $(window).resize(function () {
        setHeightResizeFunc();
      });
      setHeightResizeFunc();
    });
    function setHeightResizeFunc() {
      const rightHeight =
        $(".right-box .ibox-title").height() +
        $(".right-box .ibox-content").height() -
        45;
      $(".docLists").height(rightHeight);
    }

    // this.fnFindActiveAdminDocuments();
    this.findUserDetails(this.loggedInUserId);
    this.findSignedGroups(this.loggedInUserId);
    this.findCompanyDefaultGroup(this.loggedInUserId);
  }

  findUserDetails(userId) {
    const finalData = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      id: userId,
    };
    return this.http
      .post(
        this.appConfig.getLambdaUrl03() + ApiHelper.name_getUserDetailApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          if (apiResponse.commandResult.status == 1) {
            this.docGroupId =
              apiResponse.commandResult.data.userInfo.DocGroupId;
            this.docGroupTitle =
              apiResponse.commandResult.data.userInfo.GroupTitle;
            this.profileObj = apiResponse.commandResult.data.userInfo;
            // console.log(this.profileObj.DocGroupId);
            this.activeGroupId = this.profileObj.DocGroupId;
            this.docSet = this.profileObj.DocGroupId;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  findCompanyDefaultGroup(userId) {
    const finalData = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      loggedInUserId: userId,
    };
    return this.http
      .post(
        this.appConfig.getLambdaUrl03() +
          ApiHelper.name_getCompanyDefaultGroupApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.companyDefaultGroupTitle =
            apiResponse.commandResult.data.companyDefaultGroup.GroupTitle;
          this.companyDefaultGroupId =
            apiResponse.commandResult.data.companyDefaultGroup.Id;
          this.fnFindGroupDocs();
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  showDemographicForm() {
    const httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
    });
    const options = {
      headers: httpHeaders,
    };
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      demographicId: this.demographicId,
    };
    return this.http
      .post(
        this.appConfig.getPhpUrl() + ApiHelper.php_generateDemographicPdfApi,
        finalData,
        options
      )
      .subscribe(
        async (apiResponse) => {
          this.resultJsonObj = apiResponse;
          // console.log(this.resultJsonObj);
          if (this.resultJsonObj.commandResult.success == 1) {
            // console.log(this.resultJsonObj.commandResult.data);

            // this.demographicUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.resultJsonObj.commandResult.data
            );
          } else {
            // alert(oops! error occured, please try later");

            const alertStatus = await this.sweetAlertHelper.alertPopUp(
              this.message.alertMessages.allotDocgrpComp.onSubmi1
            );
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  showHippaForm() {
    const httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
    });
    const options = {
      headers: httpHeaders,
    };
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      demographicId: this.demographicId,
    };

    return this.http
      .post(
        this.appConfig.getPhpUrl() + ApiHelper.php_generateHippaRealeasPdfApi,
        finalData,
        options
      )
      .subscribe(
        async (apiResponse) => {
          this.resultJsonObj = apiResponse;
          // console.log(this.resultJsonObj);
          if (this.resultJsonObj.commandResult.success == 1) {
            this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.resultJsonObj.commandResult.data
            );
          } else {
            // alert("oops! error occured, please try later");

            const alertStatus = await this.sweetAlertHelper.alertPopUp(
              this.message.alertMessages.allotDocgrpComp.onSubmi1
            );
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  showDisclaimerForm() {
    const httpHeaders = new HttpHeaders({
      "Content-Type": "application/json",
    });
    const options = {
      headers: httpHeaders,
    };
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      demographicId: this.demographicId,
    };

    return this.http
      .post(
        this.appConfig.getPhpUrl() +
          ApiHelper.php_generateWaiverDisclaimerPdfApi,
        finalData,
        options
      )
      .subscribe(
        async (apiResponse) => {
          this.resultJsonObj = apiResponse;
          if (this.resultJsonObj.commandResult.success == 1) {
            // console.log(apiResponse);
            // this.disclaimerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
              this.resultJsonObj.commandResult.data
            );
          } else {
            // alert("oops! error occured, please try later");

            const alertStatus = await this.sweetAlertHelper.alertPopUp(
              this.message.alertMessages.allotDocgrpComp.onSubmi1
            );
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  goToDemographicForm() {
    this.router.navigate(["/demographicsform/" + this.loggedInUserId]);
  }

  async editDemographicForm5() {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: Are you sure, you want to modify your demographic information."
    //   )
    // )

    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.doctordocComp.editDemographicForm5
    );
    if (alertStatus) {
      this.router.navigate([
        "/edit-demographic-5/" + this.loggedInUserId + "/" + this.demographicId,
      ]);
    }
  }

  async editSignature() {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: Are you sure, you want to change your signature."
    //   )
    // )
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.adminDocReviewComp.editSignature
    );
    if (alertStatus) {
      this.router.navigate([
        "/signaturewaiver/" + this.loggedInUserId + "/" + this.demographicId,
      ]);
    }
  }

  async signOff() {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: After submitting, you should receive all documents by email."
    //   )
    // )
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.docReviewComp.signOff
    );
    {
      this.showDocThumbnails = false;

      const httpHeaders = new HttpHeaders({
        "Content-Type": "application/json",
      });
      const options = {
        headers: httpHeaders,
      };
      const finalData = {
        loggedInUserId: this.loggedInUserId,
        demographicId: this.demographicId,
        company_slug: ConstantHelper.COMPANY_SLUG,
      };

      return this.http
        .post(
          this.appConfig.getPhpUrl() + ApiHelper.php_generateDemographicPdfApi,
          finalData,
          options
        )
        .subscribe(
          (apiResponse) => {
            this.http
              .post(
                this.appConfig.getPhpUrl() +
                  ApiHelper.php_generateHippaRealeasPdfApi,
                finalData,
                options
              )
              .subscribe(
                (apiResponse) => {
                  this.http
                    .post(
                      this.appConfig.getPhpUrl() +
                        ApiHelper.php_generateWaiverDisclaimerPdfApi,
                      finalData,
                      options
                    )
                    .subscribe(
                      (apiResponse) => {
                        this.http
                          .post(
                            this.appConfig.getPhpUrl() +
                              ApiHelper.php_sendSignOffMailApi,
                            finalData,
                            options
                          )
                          .subscribe(
                            (apiResponse) => {
                              this.resultJsonObj = apiResponse;
                              // console.log(this.resultJsonObj);

                              this.http
                                .post(
                                  this.appConfig.getPhpAhsUrl() +
                                    ApiHelper.ahs_uploadFile2ElemrexApi,
                                  finalData,
                                  options
                                )
                                .subscribe(
                                  (apiResponse) => {
                                    this.resultJsonObj = apiResponse;
                                    // console.log(this.resultJsonObj);
                                    // this.router.navigate(["/"]);
                                    this.router.navigate([
                                      "/dashboard/" + this.loggedInUserId,
                                    ]);
                                  },
                                  (err) => {
                                    // console.log(err);
                                  }
                                );
                            },
                            (err) => {
                              // console.log(err);
                            }
                          );
                      },
                      (err) => {
                        // console.log(err);
                      }
                    );
                },
                (err) => {
                  // console.log(err);
                }
              );
          },
          (err) => {
            // console.log(err);
          }
        );
    }
  }

  showDocument(documentId, documentUrl, docTyep) {
    this.selectedDocId = documentId;
    this.docTyep = docTyep;
    this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(documentUrl);
    this.showDeleteButton = true;
  }

  async onReset() {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: Are you certain you want to return to the Home Page?"
    //   )
    // )
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.adminChangePassComp.onReset
    );
    if (alertStatus) {
      this.router.navigate(["/dashboard/" + this.loggedInUserId]);
    }
  }

  selectDocGroup(docSet) {
    // alert('sadsasa');
    this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl("");
    this.showDeleteButton = false;
    if (docSet == "A") {
      this.fnFindAllDocuments();
    } else if (docSet == "U") {
      this.fnFindUploadedDocs();
    } else if (docSet == "DS") {
      this.fnFindDoctorAcknowledgments();
    } else {
      this.activeGroupId = docSet;
      this.fnFindGroupDocs();
    }
  }

  fnFindActiveAdminDocuments() {
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      company_slug: ConstantHelper.COMPANY_SLUG,
    };
    this.http
      .post(
        this.appConfig.getLambdaUrl02() +
          ApiHelper.name_getActiveAdminDocumentsListApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.resultJsonObj = apiResponse;
          // console.log(this.resultJsonObj);
          if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
            this.documentsLength = true;
            this.documentsList =
              this.resultJsonObj.commandResult.data.documentList;
            // console.log(this.documentsList);
          } else {
            this.documentsLength = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  fnFindAllDocuments() {
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      company_slug: ConstantHelper.COMPANY_SLUG,
      email: this.profileObj.Email,
    };
    this.http
      .post(
        this.appConfig.getLambdaUrl03() + ApiHelper.name_findAllDocumentsApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.resultJsonObj = apiResponse;
          // console.log('All Documents', this.resultJsonObj);
          if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
            this.documentsLength = true;
            this.documentsList =
              this.resultJsonObj.commandResult.data.documentList;
          } else {
            this.documentsLength = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  fnFindDefaultDocuments() {
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      company_slug: ConstantHelper.COMPANY_SLUG,
      email: this.profileObj.Email,
    };
    this.http
      .post(
        this.appConfig.getLambdaUrl03() +
          ApiHelper.name_findDefaultDocumentsApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.resultJsonObj = apiResponse;
          // console.log('Default Documents', this.resultJsonObj);

          if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
            this.documentsLength = true;
            this.documentsList =
              this.resultJsonObj.commandResult.data.documentList;
          } else {
            this.documentsLength = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  fnFindGroupDocs() {
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      company_slug: ConstantHelper.COMPANY_SLUG,
      doc_group_id: this.activeGroupId,
      default_group_id: this.companyDefaultGroupId,
      email: this.profileObj.Email,
    };

    this.http
      .post(
        this.appConfig.getLambdaUrl03() + ApiHelper.name_findDocsBySubGroupApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.resultJsonObj = apiResponse;
          // console.log('Sub Group Documents', this.resultJsonObj);
          if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
            this.documentsLength = true;
            this.documentsList =
              this.resultJsonObj.commandResult.data.documentList;
            // console.log(this.documentsList);
          } else {
            this.documentsLength = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  fnFindUploadedDocs1() {
    // console.log(this.profileObj.Email);
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      company_slug: ConstantHelper.COMPANY_SLUG,
      docType: ConstantHelper.DOC_TYPE_USER_UPLOADED,
      email: this.profileObj.Email,
    };
    // console.log(finalData);
    // return;

    this.http
      .post(
        this.appConfig.getLambdaUrl03() +
          ApiHelper.name_getUploadedDocumentsList,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.resultJsonObj = apiResponse;
          // console.log('Uploaded Documents', this.resultJsonObj);
          // console.log(this.resultJsonObj);
          if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
            this.documentsLength = true;
            this.documentsList =
              this.resultJsonObj.commandResult.data.documentList;
            // console.log(this.documentsList);
          } else {
            this.documentsLength = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  fnFindUploadedDocs() {
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      company_slug: null,
      docType: ConstantHelper.DOC_TYPE_USER_UPLOADED,
    };
    this.http
      .post(
        this.appConfig.getLambdaUrl03() +
          ApiHelper.name_getUploadedDocumentsList,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (res: any) => {
          if (res.commandResult.data.documentList.length > 0) {
            this.documentsList = res.commandResult.data.documentList;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  async deleteDoc() {
    // if (confirm("PLEASE CONFIRM: Are you sure, you want to delete"))
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.adminDocReviewComp.deleteDoc
    );
    {
      const finalData = {
        docId: this.selectedDocId,
      };
      return this.http
        .post(
          this.appConfig.getPhpUrl() + ApiHelper.php_deleteDocApi,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse: any) => {
            this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl("");
            this.showDeleteButton = false;
            this.fnFindUploadedDocs();
          },
          (err) => {
            // console.log(err);
          }
        );
    }
  }

  async clearViewr() {
    // if (confirm("PLEASE CONFIRM: Are you sure, you want to clear preview?"))
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.adminDocReviewComp.clearViewr
    );
    {
      this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl("");
      this.showDeleteButton = false;
    }
  }

  ////////////////////////////////////////////////////////

  findSignedGroups(userId) {
    const finalData = {
      company_slug: ConstantHelper.COMPANY_SLUG,
      loggedInUserId: userId,
    };
    return this.http
      .post(
        this.appConfig.getPhpUrl() + ApiHelper.php_findUserDocumentGroupsApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse: any) => {
          this.signedGroups = apiResponse.commandResult.data.DocGroupd;
          this.signedGroupsCount =
            apiResponse.commandResult.data.DocGroupd.length;
        },
        (err) => {
          // console.log(err);
        }
      );
  }

  fnFindDoctorAcknowledgments() {
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      company_slug: ConstantHelper.COMPANY_SLUG,
      docType: 7,
    };
    this.http
      .post(
        this.appConfig.getLambdaUrl04() +
          ApiHelper.name_getAcknowledgmentDocumentsList,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.resultJsonObj = apiResponse;
          if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
            this.documentsLength = true;
            this.documentsList =
              this.resultJsonObj.commandResult.data.documentList;
          } else {
            this.documentsLength = false;
          }
        },
        (err) => {
          // console.log(err);
        }
      );
  }
}
